export default "__VITE_ASSET__CzcbQ2UM__"